var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('custom-alert'),_c('upcoming-elections',{attrs:{"loading":_vm.loadingUpcoming},on:{"set-vote-loader":_vm.setUpcomingRequestLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }